// Modal.js
import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, children, onSubmit, onCancel }) => {
    if (!isOpen) return null;
  
    const handleOverlayClick = (e) => {
      if (e.target === e.currentTarget) {
        onCancel();
      }
    };
  
    const handleCancelClick = () => {
      if (onCancel) {
        onCancel();
      }
      onClose(); // Close the modal after handling cancel action
    };
  
    return (
      <div className="modal-overlay" onClick={handleOverlayClick}>
        <div className="modal-container">
          <div className="modal-header">
            <span className="modal-title">{title}</span>
            <button className="modal-close" onClick={handleCancelClick}>
              &times;
            </button>
          </div>
          <div className="modal-body">
            {children}
          </div>
          <div className="modal-footer">
            <button type="button" className="modal-button cancel" onClick={handleCancelClick}>
              Cancel
            </button>
            <button type="button" className="modal-button" onClick={onSubmit}>
              Send
            </button>
          </div>
        </div>
      </div>
    );
  };

export default Modal;
